'use client';
import type { Assign } from '@ark-ui/react';
import { TagsInput } from '@ark-ui/react';
import { type TagsInputVariantProps, tagsInput } from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(tagsInput);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, TagsInput.RootProviderProps>,
    TagsInputVariantProps
  >
>(TagsInput.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, TagsInput.RootProps>,
    TagsInputVariantProps
  >
>(TagsInput.Root, 'root');

export const ClearTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, TagsInput.ClearTriggerProps>
>(TagsInput.ClearTrigger, 'clearTrigger');

export const Control = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, TagsInput.ControlProps>
>(TagsInput.Control, 'control');

export const Input = withContext<
  HTMLInputElement,
  Assign<HTMLStyledProps<'input'>, TagsInput.InputProps>
>(TagsInput.Input, 'input');

export const ItemDeleteTrigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, TagsInput.ItemDeleteTriggerProps>
>(TagsInput.ItemDeleteTrigger, 'itemDeleteTrigger');

export const ItemInput = withContext<
  HTMLInputElement,
  Assign<HTMLStyledProps<'input'>, TagsInput.ItemInputProps>
>(TagsInput.ItemInput, 'itemInput');

export const ItemPreview = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, TagsInput.ItemPreviewProps>
>(TagsInput.ItemPreview, 'itemPreview');

export const Item = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, TagsInput.ItemProps>
>(TagsInput.Item, 'item');

export const ItemText = withContext<
  HTMLSpanElement,
  Assign<HTMLStyledProps<'span'>, TagsInput.ItemTextProps>
>(TagsInput.ItemText, 'itemText');

export const Label = withContext<
  HTMLLabelElement,
  Assign<HTMLStyledProps<'label'>, TagsInput.LabelProps>
>(TagsInput.Label, 'label');

export {
  TagsInputContext as Context,
  TagsInputHiddenInput as HiddenInput,
} from '@ark-ui/react';
